import React from 'react';
import { Outlet } from 'react-router-dom';

const UserNotLogin = ({
  title = 'GBase',
  hasHeader = true
}: {
  title?: string;
  hasHeader?: boolean;
}) => {
  return (
    <React.Fragment>
      {hasHeader && (
        <header className="p-5 text-center">
          <h1 className="font-bold text-xl">{title}</h1>
        </header>
      )}
      <main
        className={`${hasHeader ? 'bg-gray-100 min-h-screen max-sm:pt-8 sm:py-6' : ''}`}
      >
        <Outlet />
      </main>
    </React.Fragment>
  );
};

export default UserNotLogin;
